/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Personal Health Record API
 * API for PHR
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import { exists, mapValues } from "../runtime";
import {
  PhrAnemia,
  PhrAnemiaFromJSON,
  PhrAnemiaFromJSONTyped,
  PhrAnemiaToJSON,
  PhrClinicalDocumentResult,
  PhrClinicalDocumentResultFromJSON,
  PhrClinicalDocumentResultFromJSONTyped,
  PhrClinicalDocumentResultToJSON,
  PhrElectrocardiogram,
  PhrElectrocardiogramFromJSON,
  PhrElectrocardiogramFromJSONTyped,
  PhrElectrocardiogramToJSON,
  PhrFunduscopy,
  PhrFunduscopyFromJSON,
  PhrFunduscopyFromJSONTyped,
  PhrFunduscopyToJSON,
  PhrMedicationReconciliationForm,
  PhrMedicationReconciliationFormFromJSON,
  PhrMedicationReconciliationFormFromJSONTyped,
  PhrMedicationReconciliationFormToJSON,
  PhrSerumCreatinine,
  PhrSerumCreatinineFromJSON,
  PhrSerumCreatinineFromJSONTyped,
  PhrSerumCreatinineToJSON,
} from "./";

export const PhrSpecificHealthCheckupTypename = "PhrSpecificHealthCheckup" as const;

/**
 *
 * @export
 * @interface PhrSpecificHealthCheckup
 */
export interface PhrSpecificHealthCheckup {
  /**
   *
   * @type {PhrAnemia}
   * @memberof PhrSpecificHealthCheckup
   */
  anemia?: PhrAnemia;
  /**
   *
   * @type {string}
   * @memberof PhrSpecificHealthCheckup
   */
  diagnosis?: string;
  /**
   *
   * @type {string}
   * @memberof PhrSpecificHealthCheckup
   */
  effectiveTime?: string;
  /**
   *
   * @type {PhrElectrocardiogram}
   * @memberof PhrSpecificHealthCheckup
   */
  electrocardiogram?: PhrElectrocardiogram;
  /**
   *
   * @type {PhrFunduscopy}
   * @memberof PhrSpecificHealthCheckup
   */
  funduscopy?: PhrFunduscopy;
  /**
   *
   * @type {string}
   * @memberof PhrSpecificHealthCheckup
   */
  importType: PhrSpecificHealthCheckupImportTypeEnum;
  /**
   *
   * @type {Date}
   * @memberof PhrSpecificHealthCheckup
   */
  importedTime?: string;
  /**
   *
   * @type {string}
   * @memberof PhrSpecificHealthCheckup
   */
  medicalInstitutionName?: string;
  /**
   *
   * @type {PhrMedicationReconciliationForm}
   * @memberof PhrSpecificHealthCheckup
   */
  medicationReconciliationForm?: PhrMedicationReconciliationForm;
  /**
   *
   * @type {PhrClinicalDocumentResult}
   * @memberof PhrSpecificHealthCheckup
   */
  result?: PhrClinicalDocumentResult;
  /**
   *
   * @type {PhrSerumCreatinine}
   * @memberof PhrSpecificHealthCheckup
   */
  serumCreatinine?: PhrSerumCreatinine;
  /**
   * Resource type name
   * @type {string}
   * @memberof PhrSpecificHealthCheckup
   */
  readonly __typename?: string;
}

/**
 * @export
 * @enum {string}
 */
export enum PhrSpecificHealthCheckupImportTypeEnum {
  Myna = "myna",
  File = "file",
}

export function PhrSpecificHealthCheckupFromJSON(json: any): PhrSpecificHealthCheckup {
  return PhrSpecificHealthCheckupFromJSONTyped(json, false);
}

export function PhrSpecificHealthCheckupFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PhrSpecificHealthCheckup {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    __typename: PhrSpecificHealthCheckupTypename,

    anemia: !exists(json, "anemia") ? undefined : PhrAnemiaFromJSON(json["anemia"]),
    diagnosis: !exists(json, "diagnosis") ? undefined : json["diagnosis"],
    effectiveTime: !exists(json, "effective_time") ? undefined : json["effective_time"],
    electrocardiogram: !exists(json, "electrocardiogram")
      ? undefined
      : PhrElectrocardiogramFromJSON(json["electrocardiogram"]),
    funduscopy: !exists(json, "funduscopy") ? undefined : PhrFunduscopyFromJSON(json["funduscopy"]),
    importType: json["import_type"],
    importedTime:
      !exists(json, "imported_time") ||
      (typeof json["imported_time"] === "string" && json["imported_time"].substring(0, 4) === "0001")
        ? undefined
        : json["imported_time"],
    medicalInstitutionName: !exists(json, "medical_institution_name") ? undefined : json["medical_institution_name"],
    medicationReconciliationForm: !exists(json, "medication_reconciliation_form")
      ? undefined
      : PhrMedicationReconciliationFormFromJSON(json["medication_reconciliation_form"]),
    result: !exists(json, "result") ? undefined : PhrClinicalDocumentResultFromJSON(json["result"]),
    serumCreatinine: !exists(json, "serum_creatinine")
      ? undefined
      : PhrSerumCreatinineFromJSON(json["serum_creatinine"]),
  };
}

export function PhrSpecificHealthCheckupToJSON(object?: PhrSpecificHealthCheckup | null): any {
  if (object === undefined) {
    return undefined;
  }
  if (object === null) {
    return null;
  }
  const { __typename, ...value } = object;
  return {
    anemia: PhrAnemiaToJSON(value.anemia),
    diagnosis: value.diagnosis,
    effective_time: value.effectiveTime,
    electrocardiogram: PhrElectrocardiogramToJSON(value.electrocardiogram),
    funduscopy: PhrFunduscopyToJSON(value.funduscopy),
    import_type: value.importType,
    imported_time: value.importedTime === undefined ? undefined : tzDate(value.importedTime).format(),
    medical_institution_name: value.medicalInstitutionName,
    medication_reconciliation_form: PhrMedicationReconciliationFormToJSON(value.medicationReconciliationForm),
    result: PhrClinicalDocumentResultToJSON(value.result),
    serum_creatinine: PhrSerumCreatinineToJSON(value.serumCreatinine),
  };
}
